<template>
  <ModalContainer :show="show" @close="close">
    <div class="add-task-modal" style="width: 480px">
      <h2 class="text-4 mb-4">New Task</h2>

      <TaskForm
        v-if="show"
        ref="taskForm"
        :related-record="relatedRecord"
        :initial="initial"
        @created="handleCreated"
      />

      <div class="field is-grouped justify-end mt-5">
        <div class="control">
          <button class="btn btn-sm" @click="close">Cancel</button>
        </div>
        <div class="control">
          <button
            class="btn btn-sm btn-primary"
            :disabled="!taskForm?.canSubmit"
            @click="taskForm?.submit()"
          >
            {{ taskForm?.submitting ? "Creating..." : "Create Task" }}
          </button>
        </div>
      </div>
    </div>
  </ModalContainer>
</template>

<script setup lang="ts">
import { ref } from "vue"
import { useRouter } from "vue-router"
import type { RecordFieldsFragment } from "@auger/core/gql/types"
import ModalContainer from "@auger/ui/components/ModalContainer.vue"
import TaskForm from "@/components/tasks/TaskForm.vue"

const props = defineProps({
  show: { type: Boolean, default: false },
  /** Record to pre-link. Falls back to the current route's record when null. */
  relatedRecord: { type: Object, default: null },
  /** A name, description and linked records for the task to start with. */
  initial: { type: Object, default: null },
  /** Open the new task after creating it; false stays where you are. */
  navigate: { type: Boolean, default: true },
})

const emit = defineEmits(["close", "created"])

const router = useRouter()
const taskForm = ref<InstanceType<typeof TaskForm> | null>(null)

function close() {
  emit("close")
}

// The form is remounted per open (v-if), so every open starts blank.
function handleCreated(record: RecordFieldsFragment) {
  emit("created", record)
  close()
  if (props.navigate) router.push(`/r/task/${record.slug}`)
}
</script>
